export default "__VITE_ASSET__68f2bac9__"